{
  "api": {
    "locationValidationTitle": "No pudimos validar tu ubicación",
    "thresholdTitle": "No estás a tiempo para registrarte",
    "warehouseUnavailableTitle": "Almacén no disponible",
    "warehouseUnavailableMessage": "Por favor contacta al personal de la instalación para proceder con el registro manual",
    "characterLimitTitle": "La entrada supera el límite de caracteres",
    "genericTitle": "El registro falló. Por favor, inténtalo de nuevo.",
    "recaptchaTitle": "La verificación falló",
    "recaptchaMessage": "No pudimos verificar tu solicitud. Por favor inténtalo de nuevo o contacta al personal de la instalación."
  }
}
